/* eslint-disable react/jsx-indent */
import React, { useCallback, useEffect, useState } from 'react';
import {
    Button,
    Toast,
    NoticeBar,
    Form,
    Input,
    ImageUploader,
} from 'antd-mobile';
import { useLocation } from 'react-router-dom';
import Connect from '@store/connect';
import dayjs from 'dayjs';
import axios from 'axios';
import urCode from '@images/urcode.jpg';
import { useNavigate } from 'react-router-dom';
import './index.scss';

const maxCount = 1;

const fetchData = async taskId => {
    const res = await axios({
        url: `/api/task/fe-detail/${taskId}`,
        method: 'get',
    });
    if (res.data.status) {
        return res.data.data;
    } else {
        return {};
    }
};

const fields = [
    {
        title: '项目名称',
        key: 'task_name',
    },
    {
        title: '项目编号',
        key: 'task_id',
    },
    {
        title: '文件获取时间',
        key: 'sign_start_time',
    },
    {
        title: '结束获取时间',
        key: 'sign_end_time',
    },
    {
        title: '平台使用费',
        key: 'task_fee',
    },
    {
        title: '文件联系人',
        key: 'task_contacter',
    },
    {
        title: '获取联系电话',
        key: 'task_phone',
    },
];

const Detail = () => {
    const [detail, setDetail] = useState({});
    const [visible, setVisible] = useState(false);
    const [disable, setDisable] = useState(false);
    const [fetch, setFetch] = useState(false);
    const [time, setTime] = useState(0);
    const [form] = Form.useForm();
    const location = useLocation();
    const urlId = /\?id=(\d+)/.exec(window.location.href)[1];
    const forceSubmit = /forceSubmit/.exec(window.location.href);
    const { id } = location.state || { id: urlId };
    const navigate = useNavigate();
    const init = useCallback(async () => {
        const res = await fetchData(id);
        if (!Object.keys(res).length) {
            Toast.show({
                icon: 'fail',
                content: '获取数据失败！',
            });
            return;
        }
        const { sign_start_time, sign_end_time, task_start_time } = res;
        const data = {
            ...res,
            sign_start_time: dayjs(sign_start_time).format('YYYY-MM-DD HH:mm'),
            sign_end_time: dayjs(sign_end_time).format('YYYY-MM-DD HH:mm'),
            task_start_time: dayjs(task_start_time).format('YYYY-MM-DD HH:mm'),
        };
        if (
            dayjs().isAfter(dayjs(sign_end_time)) ||
            dayjs().isBefore(dayjs(sign_start_time))
        ) {
            setFetch(false);
        } else {
            setFetch(true);
        }
        setDetail(data);
    }, [id]);

    useEffect(() => {
        init();
    }, []);

    const onFinish = useCallback(
        async values => {
            const { phone, password, tradeImage, bid_files } = values;
            if (phone.length !== 11) {
                Toast.show('手机号格式非法');
                return;
            }
            if (password.length !== 6) {
                Toast.show('请输入6位验证码');
                return;
            }
            if (tradeImage.length <= 0) {
                Toast.show('交易截图未上传');
                return;
            }
            if (bid_files.length <= 0) {
                Toast.show('投标文件未上传');
                return;
            }
            setFetch(false);
            Toast.show('解析图片中，请稍等...');
            const res = await axios.post('/api/bid/add', {
                ...values,
                taskId: id,
                taskName: detail.task_name,
                userId: detail.user_id,
                file_location: detail.file_location,
                taskByEmail: detail.task_by_email || '0',
                tradeImage: tradeImage.map(v => v.url),
                bid_files: bid_files.map(v => v.url),
            });
            if (res.data.status) {
                Toast.show('提交成功');
                setFetch(true);
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } else {
                Toast.show(res.data.msg);
                setFetch(true);
            }
        },
        [detail, id]
    );

    const sendCode = async () => {
        const { phone } = form.getFieldsValue();
        // 增加对手机号还有项目重复的校验
        const res = await axios.get(
            `/api/bid/check-phone?bid_phone=${phone}&task_id=${id}`
        );
        if (res.data.status && res.data.data === 'exist') {
            setVisible(true);
        } else {
            setVisible(false);
        }
        if (/^1[3|4|5|7|8|9][0-9]{9}$/.test(phone)) {
            const r = await axios.get(`/api/bid/get-sms-code?tel=${phone}`);
            if (r.data.status) {
                Toast.show({
                    icon: 'success',
                    content: '发送成功',
                });
                setDisable(true);
                setTime(60);
            } else {
                Toast.show({
                    icon: 'fail',
                    content: '发送失败请稍候',
                });
            }
        } else {
            Toast.show({
                icon: 'fail',
                content: '手机号非法',
            });
        }
    };

    useEffect(() => {
        setTimeout(() => {
            if (time > 0) {
                setTime(time - 1); // 在这不依赖于外部的 `count` 变量
            } else {
                setDisable(false);
            }
        }, 1000);
    }, [time]);

    return (
        <>
            <div className="header">项目详情</div>
            <div className="container">
                {fields.map((v, i) => (
                    <div className="row" key={`${i}`}>
                        <span>{v.title}</span>
                        <span className="content">{detail[v.key] || ''}</span>
                    </div>
                ))}
                <NoticeBar
                    content="支付提示:支付宝扫描下方二维码进行支付，如同一项目二次提交则无需重复付款，如有疑问请咨询项目联系人"
                    color="alert"
                />
                <img
                    src={urCode}
                    alt=""
                    style={{ margin: 'auto 10%', width: '80%' }}
                />

                <Form
                    name="form"
                    form={form}
                    onFinish={onFinish}
                    footer={
                        <Button
                            block
                            type="submit"
                            color="primary"
                            disabled={forceSubmit ? false : !fetch}
                        >
                            提交
                        </Button>
                    }
                >
                    <Form.Item
                        name="supplier"
                        label="投标人(供应商)名称"
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="请输入供应商名称" />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="联系人"
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="请输入姓名" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="电子邮件"
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="请输入邮箱" />
                    </Form.Item>
                    <Form.Item
                        name="address"
                        label="联系地址"
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="请输入联系地址" />
                    </Form.Item>
                    {visible && (
                        <div style={{ color: 'red' }}>
                            该项目已经存在本手机号投标记录，请谨慎操作！
                        </div>
                    )}
                    <Form.Item
                        name="phone"
                        label="手机号"
                        help="请输入11位手机号作为联系方式"
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="请输入手机号" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="验证码(6位)"
                        help="请输入6位验证码"
                        className="form-item"
                        extra={
                            <Button
                                color="primary"
                                className="item-btn"
                                onClick={sendCode}
                                disabled={disable}
                            >
                                {disable ? `发送中(${time}s)` : '发送验证码'}
                            </Button>
                        }
                        rules={[{ required: true }]}
                    >
                        <Input placeholder="请输入验证码" />
                    </Form.Item>
                    <Form.Item
                        name="tradeImage"
                        label={
                            <span>
                                支付凭证
                                <a
                                    href="https://suningzixunnew.oss-cn-shanghai.aliyuncs.com/baomingtupian.png"
                                    style={{ margin: '0 10px' }}
                                    target="_blank"
                                >
                                    查看样例
                                </a>
                            </span>
                        }
                        help="支付截图为支付宝账单详情页面，需完整显示支付时间和金额、付款备注需标明项目简称"
                        rules={[{ required: true }]}
                    >
                        <ImageUploader
                            upload={file => {
                                return new Promise(resolve => {
                                    const fd = new FormData();
                                    const xhr = new XMLHttpRequest();
                                    fd.append('file', file);
                                    xhr.open('POST', '/api/common/upload');
                                    xhr.send(fd);
                                    xhr.onreadystatechange = function() {
                                        if (
                                            xhr.readyState === 4 &&
                                            xhr.status === 200
                                        ) {
                                            var resp = JSON.parse(
                                                xhr.responseText
                                            );
                                            const { status, data } = resp;
                                            if (status) {
                                                resolve({ url: data });
                                            } else {
                                                Toast.show('上传失败');
                                                resolve({ url: '' });
                                            }
                                        }
                                    };
                                });
                            }}
                            multiple
                            maxCount={1}
                            onCountExceed={exceed => {
                                Toast.show(
                                    `最多选择 ${maxCount} 张图片，你多选了 ${exceed} 张`
                                );
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="bid_files"
                        label={
                            <span>
                                其他附件
                                <a
                                    href="https://suningzixunnew.oss-cn-shanghai.aliyuncs.com/baomingfujian.docx"
                                    style={{ margin: '0 10px' }}
                                    target="_blank"
                                >
                                    查看样例
                                </a>
                            </span>
                        }
                        help="请上传授权委托书等相关材料"
                        rules={[{ required: true }]}
                    >
                        <ImageUploader
                            accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            capture={false}
                            upload={file => {
                                return new Promise(resolve => {
                                    const fd = new FormData();
                                    const xhr = new XMLHttpRequest();
                                    fd.append('file', file);
                                    xhr.open('POST', '/api/common/upload');
                                    xhr.send(fd);
                                    xhr.onreadystatechange = function() {
                                        if (
                                            xhr.readyState === 4 &&
                                            xhr.status === 200
                                        ) {
                                            var resp = JSON.parse(
                                                xhr.responseText
                                            );
                                            const { status, data } = resp;
                                            if (status) {
                                                Toast.show('上传成功');
                                                resolve({ url: data });
                                            } else {
                                                Toast.show('上传失败');
                                                resolve({ url: '' });
                                            }
                                        }
                                    };
                                });
                            }}
                            multiple
                            maxCount={1}
                            onCountExceed={exceed => {
                                Toast.show(
                                    `最多选择 ${maxCount} 个文件，你多选了 ${exceed} 个`
                                );
                            }}
                        />
                    </Form.Item>
                </Form>
            </div>
        </>
    );
};

Detail.propTypes = {};

const mapStateToProps = () => {};

export default Connect(mapStateToProps)(Detail);
